/** @format */

import {MouseEvent, useState} from 'react';

import {IconButton, InputAdornment} from '@mui/material';
import {useTranslation} from 'react-i18next';

import LegacyTextField from 'components/inputs/LegacyTextField';

import {BaseTextFieldProps} from './BaseTextField';

const PasswordField = (props: BaseTextFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const {t} = useTranslation();

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const imgSrc = showPassword
    ? new URL('./images/eye_open.png', import.meta.url).href
    : new URL('./images/eye_closed.png', import.meta.url).href;

  const placeholder = () => {
    if (props.placeholder == null) {
      return t('Пароль', 'Пароль');
    }

    return props.placeholder;
  };

  return (
    <LegacyTextField
      myProps={{
        placeholderFocused: t('Не менее 3 знаков', 'Не менее 3 знаков'),
        ...props.myProps,
      }}
      type={showPassword ? 'text' : 'password'}
      slotProps={{
        htmlInput: {
          autoComplete: 'new-password',
        },
        input: {
          endAdornment: props.value ? (
            <InputAdornment position='end'>
              <IconButton
                edge='end'
                onClick={handleShowPassword}
                onMouseDown={handleMouseDownPassword}
                size='large'
              >
                <img alt='Visibility' height='24' src={imgSrc} width='24' />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
      }}
      {...props}
      placeholder={placeholder()}
    />
  );
};

export default PasswordField;
